<template>
    <div>
        <div class="notification is-warning" v-if="loading == true">
            Loading notes ...
        </div>
        <div class="notification is-danger" v-if="loading == false && notes.length == 0">
            No notes can be found.
        </div>

        <div v-if="loading == false && notes.length > 0">
           <table class="table is-fullwidth is-striped is-hoverable is-size-7" id="notestable">
                <thead>
                    <tr>
                        <th>Note</th>
                        <th>Date Added</th>
                        <th>Expires</th>
                        <th>User</th>
                        
                        <th style="width:60px" width="60">&nbsp;</th>
                        <th style="width:60px" width="60">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in notes" :key="row.id" :class="{'has-background-success-light': row.note_read === null}">
                        <td v-html="row.text"></td>
                        <td>{{ row.formatted_date  }}</td>
                        <td>{{ row.formatted_expiry_date  }}</td>
                        
                        <td>{{ row.forename }} {{ row.surname }}</td>
                        <td width="60" style="width:60">
                            <button class="button is-info is-small" :disabled="working==true" @click="markNoteAsRead(row)" v-if="row.note_read===null">Read</button>
                        </td>
                        <td width="60" style="width:60">
                            <button class="button is-danger is-small" :disabled="working==true" @click="deleteNote(row.id)">Delete</button>
                        </td>
                    </tr>
                
                </tbody>

            </table>
        </div>

        
    </div>
</template>

<script>
//import * as XLSX from 'xlsx'

import UtilityService from '@/services/UtilityService.js';
import NoteService from '@/services/NoteService.js';
//import MemberMixin from '@/mixins/MemberMixin.js';

export default {
    
      name: 'ViewNotes',
        mixins: [],
        data: function () {
            return {
                   search: '',
                   notes: [],
                   loading: true,
                  
                   accessToken: '',
                   working: false
                   
            }
        },
        methods: {
           async markNoteAsRead(row) {
                this.working = true
               
                NoteService.markNoteAsRead(this.accessToken, row.id)
                .then((response) => {
                    console.log(response)
                    row.note_read = 1;
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. ")
                        
                })
                .finally(() => {
                    this.working = false
                })
            },
            async getNotes() {
                this.loading=true
                UtilityService.getSimpleApiData(this.accessToken, "notes")
                .then(
                    (notes => {
                        this.$set(this, "notes", notes);
                        this.loading=false
                    }).bind(this)
                );
            },
             async deleteNote(note_id) {
                this.working = true
               
                NoteService.deleteNote(this.accessToken, note_id)
                .then((response) => {
                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. ")
                        
                })
                .finally(() => {
                    this.getNotes();
                    this.working = false
                })
            },
           
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getNotes();     
            });
        
        },
        computed : {
            
            
        }
    }
</script>